import React from "react"
import Link from "../component/link"
import logo from "../../assets/images/logo.svg" // Keep SVG import for logo
import { ContainerHeader } from "./includes/stylessHeader"
import { Caret, LinesMenu } from "./includes/Svgs"
import { useHeader } from "../../hooks/useHeader"
import MenuProducts from "./includes/menuProducts"
import MenuMeans from "./includes/menuMeans"

const Header = ({ currentLocation, hideLinks }) => {
  const {
    divContext,
    dataContext,
    menu,
    changeForm,
    classActive,
    handleActive,
    classBtnMenu,
    classBtnSigin,
    classBtnMobile,
    menu_principal,
  } = useHeader(currentLocation)

  return (
    <ContainerHeader>
      <div className="container flex justify-between py-6 sm:py-3 xs:py-4">
        {hideLinks ? (
          <>
            <Link className="flex self-center py-5 logo">
              <img width={153} src={logo} alt="Claus - Software contable y facturación electrónica para gestión fiscal" loading="lazy" />
            </Link>
          </>
        ) : (
          <>
            <Link className="flex self-center logo" to="/">
              <img width={153} src={logo} alt="Claus - Software contable y facturación electrónica para gestión fiscal" loading="lazy" />
            </Link>
            {menu === 0 ? (
              <nav
                id="menu-principal"
                className={divContext.classOpenMenuMobile}
              >
                <div className="-mr-2 -my-2 xs:hidden lg:hidden md:hidden text-right">
                  <button
                    onClick={() => {
                      divContext.setOpenMobile(!divContext.openMenuMobile)
                    }}
                    type="button"
                    className={classBtnMobile}
                  >
                    <span className="sr-only">Open menu</span>
                    <LinesMenu />
                  </button>
                </div>
                <ul className="md:flex self-center xs:grid">
                  <li className="flex self-center">
                    <Link to={`/producto?contador`} className={classBtnMenu}>
                      <span>{menu_principal[0]}</span>
                    </Link>
                  </li>
                  <li className="flex self-center">
                    <Link to={`/producto?empresa`} className={classBtnMenu}>
                      <span>{menu_principal[1]}</span>
                    </Link>
                  </li>
                  <li>
                    <button
                      onClick={() => {
                        handleActive(2)
                      }}
                      className={`${classBtnMenu} ${classActive[2] ?? ""}`}
                      type="button"
                    >
                      <span>{menu_principal[2]}</span>
                      <Caret />
                      <div className="sub-menu">
                        <MenuProducts currentLocation={currentLocation} />
                      </div>
                    </button>
                  </li>
                  <li className="flex self-center">
                    <Link to={`/#benefits`} className={classBtnMenu}>
                      <span>{menu_principal[3]}</span>
                    </Link>
                  </li>
                  <li>
                    <button
                      onClick={() => {
                        handleActive(4)
                      }}
                      className={`${classBtnMenu} ${classActive[4] ?? ""}`}
                      type="button"
                    >
                      <span>{menu_principal[4]}</span>
                      <Caret />
                      <div className="sub-menu">
                        <MenuMeans />
                      </div>
                    </button>
                  </li>
                  <li className="special-links flex self-center">
                    <Link
                      to="https://app1.claus.co/clauserp/htdocs/Registro/VR201610/index.htm"
                      className={classBtnSigin}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {menu_principal[5]}
                    </Link>
                  </li>
                  <li className="special-links flex self-center">
                    <a href={"https://app1.claus.co/clauserp/ingresar/"} className={classBtnSigin} rel="noopener noreferrer">
                      {menu_principal[6]}
                    </a>
                  </li>
                  <li className="flex self-center">
                    <Link to="/#contactForm" className="links">
                      {menu_principal[7]}
                    </Link>
                  </li>
                </ul>
              </nav>
            ) : (
              <>
                <button
                  onClick={() => changeForm(1)}
                  className={`link ${dataContext.step === 1 ? "active" : ""}`}
                >
                  Datos Personales
                </button>
                <button
                  onClick={() => changeForm(2)}
                  className={`link ${dataContext.step === 2 ? "active" : ""}`}
                >
                  Datos de la Empresa
                </button>
                <button
                  onClick={() => changeForm(3)}
                  className={`link ${dataContext.step === 4 ? "active" : ""}`}
                >
                  Elige Tu Plan
                </button>
                <button
                  onClick={() => changeForm(5)}
                  className={`link ${dataContext.step === 5 ? "active" : ""}`}
                >
                  Pago
                </button>
              </>
            )}
          </>
        )}
      </div>
    </ContainerHeader>
  )
}

export default Header
